module.exports = __webpack_public_path__ + "static/media/natural.a0d98b4e.jpeg";